export class NetworkDetails{
    urls: string;
    about: string;
    urlFacebook: string;
    urlTwitter: string;
}
